import { Link } from "react-router-dom";
import React, {
  useState,
  useEffect,
  useRef,
} from "react";
import {navigationService, NavItem } from "../pages/publicservice/navigationService";



const Header: React.FC = () => {

  const [openMenu, setOpenMenu] =
    useState(false);

  const [menus, setMenus] =
    useState<NavItem[]>([]);

  const menuRef =
    useRef<HTMLDivElement>(null);

  // =========================================
  // CLOSE CATEGORY MENU OUTSIDE CLICK
  // =========================================

  useEffect(() => {

    const handleClickOutside = (
      event: MouseEvent
    ) => {

      if (
        menuRef.current &&
        !menuRef.current.contains(
          event.target as Node
        )
      ) {

        setOpenMenu(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };

  }, []);

  // =========================================
  // LOAD NAVIGATION MENUS
  // =========================================

  useEffect(() => {

    loadMenus();

  }, []);

  async function loadMenus() {

    try {

      const response =
        await navigationService.getAll();

      if (response.isSuccess) {

        const activeMenus =
          (response.dataList || [])
            .filter(
              x =>
                x.status === "Active"
            )
            .sort(
              (a, b) =>
                a.displayOrder -
                b.displayOrder
            );

        setMenus(activeMenus);
      }

    } catch (error) {

      console.error(
        "Menu load failed",
        error
      );
    }
  }

  return (

    <header className="vs-header layout2">

      {/* TOP HEADER */}
      <div className="container custom-container">

        <div className="header-top">

          <div className="row align-items-center">

            {/* SEARCH */}
            <div className="col-md-4 d-none d-md-block">

              <form
                action="#"
                className="header-search"
              >

                <input
                  type="text"
                  placeholder="search"
                />

                <button
                  type="submit"
                  aria-label="search-button"
                >
                  <i className="far fa-search"></i>
                </button>

              </form>

            </div>

            {/* LOGO */}
            <div className="col-md-4 text-center">

              <div className="header-logo">

                <Link to="/">

                  <img
                    src="/assets/img/logo.png"
                    alt="Ninesister Jewels"
                    className="logo"
                  />

                </Link>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* STICKY HEADER */}
      <div className="sticky-wrapper">

        <div className="sticky-active">

          <div className="container custom-container">

            <div className="row justify-content-between align-items-center">

              {/* CATEGORY MENU */}
              <div className="col-xl-2 col-md-auto d-none d-lg-block col-auto">

                <div
                  className="menu-wrapper"
                  ref={menuRef}
                >

                  <div className="menu-category">

                    <button
                      className={`menu-toggle ${
                        openMenu
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setOpenMenu(
                          !openMenu
                        )
                      }
                    >

                      <svg
                        className="menu-icon"
                        width="31"
                        height="23"
                        viewBox="0 0 31 23"
                        fill="none"
                      >

                        <path
                          className="line line1"
                          d="M7 1.5C7 0.671573 7.67157 0 8.5 0H29.5C30.3284 0 31 0.671573 31 1.5C31 2.32843 30.3284 3 29.5 3H8.5C7.67157 3 7 2.32843 7 1.5Z"
                          fill="white"
                        />

                        <path
                          className="line line2"
                          d="M0 11.5C0 10.6716 0.671573 10 1.5 10H29.5C30.3284 10 31 10.6716 31 11.5C31 12.3284 30.3284 13 29.5 13H1.5C0.671573 13 0 12.3284 0 11.5Z"
                          fill="white"
                        />

                        <path
                          className="line line3"
                          d="M7 21.5C7 20.6716 7.67157 20 8.5 20H29.5C30.3284 20 31 20.6716 31 21.5C31 22.3284 30.3284 23 29.5 23H8.5C7.67157 23 7 22.3284 7 21.5Z"
                          fill="white"
                        />

                      </svg>

                    </button>

                    {/* CATEGORY SUB MENU */}
                    <ul
                      className={`menu-list ${
                        openMenu
                          ? "show-menu"
                          : ""
                      }`}
                    >

                      {menus.map(menu => (

                        <li
                          key={menu.menuID}
                          className="menu-item"
                        >

                          <Link
                            to={
                              menu.menuUrl
                            }
                            target={
                              menu.targetType
                            }
                          >

                            <span className="icon">
                              💎
                            </span>

                            {
                              menu.menuName
                            }

                          </Link>

                        </li>

                      ))}

                    </ul>

                  </div>

                </div>

              </div>

              {/* MAIN NAVIGATION */}
              <div className="col-xl-auto col-md-auto col-auto">

                <nav className="main-menu d-none d-lg-block">

                  <ul>

                    {menus.map(menu => (

                      <li
                        key={menu.menuID}
                        className={
                          menu.navigationSubMenus
                            ?.length > 0
                            ? "menu-item-has-children"
                            : ""
                        }
                      >

                        <Link
                          to={menu.menuUrl}
                          target={
                            menu.targetType
                          }
                        >
                          {menu.menuName}
                        </Link>

                        {/* DROPDOWN */}
                        {menu
                          .navigationSubMenus
                          ?.length > 0 && (

                          <ul className="sub-menu">

                            {menu.navigationSubMenus
                              .filter(
                                sub =>
                                  sub.status ===
                                  "Active"
                              )
                              .sort(
                                (a, b) =>
                                  a.displayOrder -
                                  b.displayOrder
                              )
                              .map(sub => (

                                <li
                                  key={
                                    sub.subMenuID
                                  }
                                >

                                  <Link
                                    to={
                                      sub.subMenuUrl
                                    }
                                    target={
                                      sub.targetType
                                    }
                                  >

                                    {
                                      sub.subMenuName
                                    }

                                  </Link>

                                </li>

                              ))}

                          </ul>

                        )}

                      </li>

                    ))}

                  </ul>

                </nav>

                {/* MOBILE MENU BUTTON */}
                <button className="vs-menu-toggle d-inline-block d-lg-none">

                  <i className="fal fa-bars"></i>

                </button>

              </div>

              {/* RIGHT SIDE */}
              <div className="col-xl-3 col-md-auto col-auto">

                <div className="header-wc">

                  {/* WISHLIST */}
                  <Link
                    className="wc-link"
                    to="/wishlist"
                  >
                    Wishlist
                  </Link>

                  {/* CART */}
                  <Link
                    className="wc-link"
                    to="/cart"
                  >
                    Bag
                    <span className="cart-count">
                      0
                    </span>
                  </Link>

                  {/* ACCOUNT */}
                  <Link
                    className="wc-link"
                    to="/my-account"
                  >
                    <i className="far fa-user"></i>
                  </Link>

                  {/* LOGIN */}
                  <Link
                    className="wc-link login-link"
                    to="/login"
                  >
                    Login
                  </Link>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </header>
  );
};

export default Header;